<div class="row">
  <div class="col-md-12">
    <div id="comment-thread">
      @for (comment of comments; track comment[$comment._id]) {
        <div class="row">
          <app-view-comment
            [comment]="comment"
            [comments]="comments"
            [canDelete]="readOnly ? false : (canDelete$(comment) | async)"
            [canEdit]="canEdit(comment)"
            (commentDeleteEvent)="onCommentDelete($event)"
            (commentEdited)="onCommentEdited(comment, $event)"
          >
          </app-view-comment>
        </div>
      }
    </div>
  </div>
</div>
